import React, { useState, useEffect } from "react";
import { NavHashLink } from "react-router-hash-link";
import Cookies from "cookies-js";

import { styled } from "../../stitches.config";
import { body } from "../commonStyles/Fonts";
import { useAuth } from "../../context/AuthContext";
import { useStores } from "../../helpers";

// dashboard elements
import DashboardWatched from "../components/DashboardWatched";
import DashboardPersonalization from "../components/DashboardPersonalization";
import DashboardAccount from "../components/DashboardAccount";
import DashboardSuggestTopic from "../components/DashboardSuggestTopic";
import { StickyContainer, Sticky } from "react-sticky";
import ZenBox from "../components/ZenBox";
import Footer from "../components/Footer"

const Dashboard: React.FC = () => {
  // Cookies.set("IS_PRIVILEGED_USER", "1");
  const [{ user }] = useAuth();
  const { UIStore } = useStores();

  const valid = user && user.valid;

  return (
    <>
      <Overlay>
        <div className="container">
          <OverlayWrapper>
            <StickyContainer>
              <Sticky topOffset={-48} style={{ height: "100%" }}>
                {({ style, isSticky }) => (
                  <StickyWrap isSticky={isSticky} style={style}>
                    <DashboardNav className={body()}>
                      {valid &&
                        <>
                          <NavHashLink to="/dashboard/#obserwowane" smooth>
                            Obserwowane
                          </NavHashLink>
                          <NavHashLink to="/dashboard/#personalizacja" smooth>
                            Personalizacja
                          </NavHashLink>
                          <NavHashLink to="/dashboard/#zglos-temat" smooth>
                            Zgłoś temat
                          </NavHashLink>
                        </>
                      }
                      <NavHashLink to="/dashboard/#konto" smooth>
                        Konto
                      </NavHashLink>
                    </DashboardNav>
                    {valid || <ZenBox />}
                  </StickyWrap>
                )}
              </Sticky>
            </StickyContainer>
            <DashboardTable>
              {valid || <Invalid>W celu odblokowania wszystkich opcji Twoje na:Temat musisz wykupić subskrybcję</Invalid>}
              {valid && <DashboardWatched />}

              {valid && <DashboardPersonalization />}
              {valid && <DashboardSuggestTopic />}
              <DashboardAccount />
            </DashboardTable>
          </OverlayWrapper>
        </div>
      </Overlay>
      <Footer />
    </>
  );
};

const Invalid = styled("div", {
  marginTop: "24px",
  marginBottom: "24px",
  padding: "16px",
  background: "$grayscale100",
  color: "$grayscale0",
  textDecoration: "none",
  textAlign: 'center',
  p: {
    margin: 0,
    "&:nth-child(2)": {
      margin: "6px 0 14px 0",
    },
  },
  span: {
    color: "$natematPrimary",
    display: "block",
  },
  a: {
    textDecoration: "none",
  },
});

const StickyWrap = styled("div", {
  variants: {
    isSticky: {
      true: {
        paddingTop: "48px"
      },
      false: {}
    }
  }
});

const Overlay = styled("div", {
  background: "$grayscale10",
  padding: "48px 0 116px 0",
  position: "relative",
  "& .container": {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
});

const OverlayWrapper = styled("div", {
  position: "relative",
  height: "100%",
  "@bp4": {
    display: "flex",
    justifyContent: "space-between",
  },
});

// nav

const DashboardNav = styled("div", {
  width: "100%",
  height: "100%",
  flexDirection: "column",
  // position: "sticky",
  alignSelf: "flex-start",
  // top: "100px",
  display: "none",
  "@bp4": {
    width: "192px",
    display: "flex",
  },
  "& .active": {
    background: "$grayscale0",
    borderLeft: "2px solid $primary",
  },
  "& a": {
    width: "100%",
    borderWidth: "0px",
    height: "38px",
    padding: "10px 14px",
    color: "$grayscale100",
    display: "block",
    marginBottom: "2px",
    "&:hover": {
      textDecoration: "none",
    },
  },
});

// tablica

const DashboardTable = styled("div", {
  width: "100%",
  "@bp4": {
    width: "732px",
  },
});

export default Dashboard;
